import baseUrl from './baseUrl';

const URL_EDIT = `${baseUrl}/forgot/edit`;

const editPassword = async (token, password, recaptchaToken) => {
  try {
    const response = await fetch(URL_EDIT, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json'
      },
      body: JSON.stringify({ token, password, recaptchaToken })
    });

    if (!response.ok) {
      if (response?.status === 403) {
        return { "error": "Erro no reCAPTCHA" };
      }

      return { "error": "Erro ao resetar a senha" };
    }

    const data = await response.json();
    
    return data;
  } catch (error) {
    console.log(error);
  }
};

export default editPassword;
